module.exports = __webpack_public_path__ + "img/lucky_900.75453336.png";